"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_CONTEXT_HIGH_SIMILARITY_THRESHOLD = exports.KNOWLEDGE_TOOL_SIMILARITY_THRESHOLD = exports.fluxUid = exports.fluxMention = exports.fluxHandle = exports.copilotUid = exports.copilotMention = exports.copilotHandle = void 0;
exports.copilotHandle = "copilot";
exports.copilotMention = `@${exports.copilotHandle}`;
exports.copilotUid = "ZlptFyOgRpgjoGMu10HDsDK5rgO2";
// New Flux AI branding constants
exports.fluxHandle = "flux";
exports.fluxMention = `@${exports.fluxHandle}`;
// Note: fluxUid is the same as copilotUid - it's the same system user
exports.fluxUid = exports.copilotUid;
exports.KNOWLEDGE_TOOL_SIMILARITY_THRESHOLD = 0.6;
exports.SYSTEM_CONTEXT_HIGH_SIMILARITY_THRESHOLD = 0.6;
//# sourceMappingURL=copilot.js.map